module.exports = __webpack_public_path__ + "img/loan_success.b4b331ed.png";